// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3_g3O","itemTitle":"ClientEmergencyInfo_itemTitle__22jt5","itemText":"ClientEmergencyInfo_itemText__34jau"};